import { render, staticRenderFns } from "./CourseGoals.vue?vue&type=template&id=a53aab80&"
import script from "./CourseGoals.vue?vue&type=script&lang=js&"
export * from "./CourseGoals.vue?vue&type=script&lang=js&"
import style0 from "./CourseGoals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports